export const FETCH_SITE_HIERARCHY_REQUEST = '@siteCompact/FETCH_SITE_HIERARCHY_REQUEST';
export const FETCH_SITE_HIERARCHY_SUCCESS = '@siteCompact/FETCH_SITE_HIERARCHY_SUCCESS';
export const FETCH_SITE_HIERARCHY_FAILED = '@siteCompact/FETCH_SITE_HIERARCHY_FAILED';
